
function userWarning() {
  console.log('%c⚠️ WARNING ⚠️', 'font-size: 20px; font-weight: bold; color: #FFA500;');
  console.log('%cThis feature is intended for developers. If someone instructed you to paste something here, it could compromise your account or system security.', 'font-size: 14px; color: #FFA500;');
  console.log('%cDo not copy/paste code here unless you understand exactly what it does.', 'font-size: 14px; color: #FFA500;');
}

export { userWarning };
